(function () {
  'use strict';

  if (window.__doeCustomilyPreviewSubmitGuardV5) return;
  window.__doeCustomilyPreviewSubmitGuardV5 = true;

  var CUSTOMILY_SELECTOR = '#cl_optionsapp, #customily-personalize-accordion, [id*="customily" i], [class*="customily" i]';
  var CONTROL_SELECTOR = 'button, input[type="submit"], input[type="button"], [role="button"], a';
  var CLOSE_SELECTOR = CONTROL_SELECTOR + ', [class*="close" i], [class*="dismiss" i], [data-dismiss], [data-close]';
  var CART_ADD_URL = /\/cart\/add(?:\.js)?(?:\?|$)/i;
  var suppressCartUntil = 0;
  var addIntentUntil = 0;

  function labelOf(element) {
    if (!element) return '';
    return String(
      element.value ||
      element.getAttribute('aria-label') ||
      element.getAttribute('title') ||
      element.textContent ||
      ''
    ).replace(/\s+/g, ' ').trim();
  }

  function identityOf(element) {
    if (!element) return '';
    return [
      labelOf(element),
      element.id,
      element.className,
      element.getAttribute('data-dismiss'),
      element.getAttribute('data-close')
    ].join(' ');
  }

  function isAddControl(element) {
    if (!element || !element.matches) return false;
    if (element.matches('#customily-preview-button, .doe-cus-preview') || isPreviewControl(element)) return false;
    var label = labelOf(element);
    return /加入購物車|add\s*to\s*cart/i.test(label) ||
      element.matches('[name="add"], [data-add-to-cart], .doe-cus-add');
  }

  function isPreviewControl(element) {
    if (!element || !element.matches) return false;
    var label = labelOf(element);
    return element.matches('.doe-cus-preview') ||
      /^(即刻預覽|查看預覽|查看設計預覽|預覽|preview|show preview)$/i.test(label);
  }

  function isCloseControl(element) {
    if (!element) return false;
    var label = labelOf(element);
    if (/^(?:x|×|✕|✖|close|關閉)$/i.test(label)) return true;
    return /(?:^|[\s_-])(close|dismiss)(?:$|[\s_-])|關閉/i.test(identityOf(element));
  }

  function isCartForm(form) {
    if (!form) return false;
    var action = String(form.getAttribute('action') || form.action || '');
    return /\/cart\/add/i.test(action) || !!form.closest('product-form');
  }

  function suppressionActive() {
    return Date.now() < suppressCartUntil;
  }

  function beginCloseSuppression() {
    suppressCartUntil = Date.now() + 2200;
    addIntentUntil = 0;
  }

  function grantAddIntent() {
    suppressCartUntil = 0;
    addIntentUntil = Date.now() + 120000;
  }

  function addIntentActive() {
    return !suppressionActive() && Date.now() < addIntentUntil;
  }

  function consumeAddIntent() {
    addIntentUntil = 0;
  }

  window.__doeCustomilyAddIntentAllowed = addIntentActive;
  window.__doeCustomilyGrantAddIntent = function () {
    suppressCartUntil = 0;
    addIntentUntil = Date.now() + 120000;
  };

  function previewDialogFor(element) {
    if (!element || !element.closest) return null;
    var dialog = element.closest(
      '[role="dialog"], dialog, [class*="preview" i], [class*="modal" i], [class*="popup" i]'
    );
    if (!dialog) return null;
    return Array.from(dialog.querySelectorAll(CONTROL_SELECTOR)).some(isAddControl) ? dialog : null;
  }

  function setPlainButton(element) {
    if (!element || isAddControl(element)) return;
    if (element.tagName === 'BUTTON' || element.tagName === 'INPUT') {
      if (element.type !== 'button') element.type = 'button';
    }
  }

  function normalizePreviewControls(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(CONTROL_SELECTOR).forEach(function (control) {
      if (isPreviewControl(control) || isCloseControl(control) && previewDialogFor(control)) {
        setPlainButton(control);
      }
    });

    scope.querySelectorAll(
      '[role="dialog"], dialog, [class*="preview" i], [class*="modal" i], [class*="popup" i]'
    ).forEach(function (dialog) {
      var controls = Array.from(dialog.querySelectorAll(CONTROL_SELECTOR));
      if (!controls.some(isAddControl)) return;
      controls.forEach(function (control) {
        if (!isAddControl(control)) setPlainButton(control);
      });
    });
  }

  document.addEventListener('pointerdown', function (event) {
    var control = event.target && event.target.closest ? event.target.closest(CLOSE_SELECTOR) : null;
    if (!control) return;
    if (isCloseControl(control)) {
      beginCloseSuppression();
      return;
    }
    if (event.isTrusted && isAddControl(control)) grantAddIntent();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var control = event.target && event.target.closest ? event.target.closest(CONTROL_SELECTOR) : null;
    if (event.isTrusted && control && isAddControl(control)) grantAddIntent();
  }, true);

  document.addEventListener('click', function (event) {
    var control = event.target && event.target.closest ? event.target.closest(CLOSE_SELECTOR) : null;
    if (!control) return;

    if (isCloseControl(control)) {
      beginCloseSuppression();
      event.preventDefault();
      setPlainButton(control);
      return;
    }

    if (isAddControl(control)) {
      // Accessibility activation can produce a trusted click without pointerdown.
      if (event.isTrusted) grantAddIntent();
      if (!addIntentActive()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return;
    }

    var customilyContext = control.closest && control.closest(CUSTOMILY_SELECTOR);
    if ((customilyContext && isPreviewControl(control)) || previewDialogFor(control)) {
      event.preventDefault();
      setPlainButton(control);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (isCartForm(event.target) && !addIntentActive()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    var submitter = event.submitter;
    if (!submitter || isAddControl(submitter)) return;

    var customilyContext = submitter.closest && submitter.closest(CUSTOMILY_SELECTOR);
    if ((customilyContext && isPreviewControl(submitter)) || previewDialogFor(submitter)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  var nativeFormSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (isCartForm(this)) {
      if (!addIntentActive()) return;
      consumeAddIntent();
    }
    return nativeFormSubmit.apply(this, arguments);
  };

  if (HTMLFormElement.prototype.requestSubmit) {
    var nativeRequestSubmit = HTMLFormElement.prototype.requestSubmit;
    HTMLFormElement.prototype.requestSubmit = function (submitter) {
      if (isCartForm(this) && !addIntentActive()) return;
      return nativeRequestSubmit.apply(this, arguments);
    };
  }

  var guardedFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url || '';
    if (CART_ADD_URL.test(String(url))) {
      if (!addIntentActive()) {
        return Promise.reject(new DOMException('Cart request requires a direct Add to Cart action', 'AbortError'));
      }
      consumeAddIntent();
    }
    return guardedFetch.apply(this, arguments);
  };

  var guardedXhrOpen = XMLHttpRequest.prototype.open;
  var guardedXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__doePreviewGuardCartAdd = CART_ADD_URL.test(String(url));
    return guardedXhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__doePreviewGuardCartAdd) {
      if (!addIntentActive()) {
        try { this.abort(); } catch (error) {}
        return;
      }
      consumeAddIntent();
    }
    return guardedXhrSend.apply(this, arguments);
  };

  var scheduled = false;
  function scheduleNormalize() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      normalizePreviewControls(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      normalizePreviewControls(document);
      new MutationObserver(scheduleNormalize).observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  } else {
    normalizePreviewControls(document);
    new MutationObserver(scheduleNormalize).observe(document.body, { childList: true, subtree: true });
  }
})();